const AdminActionTypes = {
  SET_ADMIN_USER: 'SET_ADMIN_USER',
  SET_ADMIN_TOKEN: 'SET_ADMIN_TOKEN',
};

export default AdminActionTypes;
